
export class ContainerRequest {
    containerId: number;

    /**
     * @param containerId
    */
    constructor(containerId?: number){
       this.containerId=containerId;
    }
}
export class SaleOrderIdRequest {
    saleOrderId: number;

    /**
     * @param saleOrderId
    */
    constructor(saleOrderId?: number){
       this.saleOrderId=saleOrderId;
    }
}
export class AuthorisedRequest{
    saleOrderId:number;
   authorisedId:number;


    /**
     * 
     * @param saleOrderId 
     */

   constructor(saleOrderId:number, authorisedId:number) {
        this.saleOrderId = saleOrderId;   
        this.authorisedId = authorisedId  
    }
}